import { getDurationInHours } from "../../offering/time_utils";

export interface DailyBooking {
  id: string;
  attendees: number;
  locationID: string;
  spaceID: string;
  spaceType: string;
  orderID: string;
  orderConfirmationID: string;
  orderCreatedAt: Date | null;
  orderName: string;
  orderEmail: string;
  bookingType: BookingType.Daily;
  layoutID: string;
  room: string;
  floor: string;
  physicalSpaceID: string;
  days: number;
  startDate: string;
  endDate: string;
  cancellationAllowed: boolean;
  cancellationAllowedBefore: Date | null;
  time: string | null;
  duration: string;
  productType?: {
    id: string;
    name: string;
  };
}

export enum BookingType {
  Hourly = "hourly",
  Daily = "daily",
}

export interface HourlyBooking {
  id: string;
  attendees: number;
  locationID: string;
  spaceID: string;
  spaceType: string;
  orderID: string;
  orderConfirmationID: string;
  orderCreatedAt: Date | null;
  orderName: string;
  orderEmail: string;
  bookingType: BookingType.Hourly;
  room: string;
  floor: string;
  layoutID: string;
  physicalSpaceID: string;
  date: string;
  cancellationAllowed: boolean;
  cancellationAllowedBefore: Date | null;
  time: string;
  duration: string;
  productType?: {
    id: string;
    name: string;
  };
}

export type Booking = DailyBooking | HourlyBooking;

export function toBooking(data: any): Booking {
  const duration =
    data.end_time && data.start_time
      ? String(getDurationInHours(data.end_time, data.start_time))
      : data.duration;

  return {
    id: data.id,
    attendees: data.attendees,
    locationID: data.location_id,
    spaceID: data.space_id,
    spaceType: data.space_type,
    bookingType: data.booking_type,
    layoutID: data.space_layout_id,
    date: data.date,
    time: data.time || data.start_time,
    duration: duration,
    startDate: data.start_date,
    endDate: data.end_date,
    room: data.name,
    days: data.days || data.duration,
    floor: data.floor,
    orderID: data.order_id,
    orderConfirmationID: data.order_confirmation_id,
    orderCreatedAt: new Date(data.order_created_at * 1000), // unix timestamp in SECONDS
    orderName: data.order_fullname,
    orderEmail: data.order_email,
    physicalSpaceID: data.physical_space_id,
    cancellationAllowed: data.cancellation_allowed,
    cancellationAllowedBefore: data.cancellation_allowed_before
      ? // unix timestamp in SECONDS
        new Date(data.cancellation_allowed_before * 1000)
      : null,
    productType: data.product_type,
  };
}
